export default __webpack_public_path__ + "loaderIcon.fd4eb9a7.png";